import { render, staticRenderFns } from "./getFileView.vue?vue&type=template&id=b9b49574&scoped=true&"
import script from "./getFileView.vue?vue&type=script&lang=js&"
export * from "./getFileView.vue?vue&type=script&lang=js&"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9b49574",
  null
  
)

export default component.exports